<template>
  <el-dialog
    title="打卡配置"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    width="30%"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <div class="left">
        <el-form :model="formInline" ref="form" :rules="rules">
          <el-form-item label="打卡地点经度">
            <el-input
              style="width: 356px;"
              v-model="formInline.extendLongitude"
              placeholder="打卡地点经度"
            >
              <template slot="append">°E</template>
            </el-input>
          </el-form-item>
          <el-form-item label="打卡地点纬度">
            <div style="display:flex;">
              <el-input
                style="width: 356px;"
                v-model="formInline.extendLatitude"
                placeholder="打卡地点纬度"
              >
                <template slot="append">°N</template>
              </el-input>
              <el-button
                @click="mapVisible = true"
                type="text"
                style="margin-left: 16px;"
                >地图定位</el-button
              >
            </div>
          </el-form-item>
          <el-form-item label="打卡范围要求">
            <el-input
              style="width: 356px;"
              v-model="formInline.extendRangeMetre"
              placeholder="打卡范围要求"
              type="number"
            >
              <span slot="append">米</span>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="addOrUpdateFun" :loading="saving"
        >保 存</el-button
      >
    </span>
    <mapSearch
      @cancel="mapVisible = false"
      @map-confirm="confirmLocation"
      :visible="mapVisible"
    ></mapSearch>
  </el-dialog>
</template>
<script>
import { mangerDetail, mangerEdit } from "@/api/onDutyAndStandBy.js";
import mapSearch from "@/components/map-search/index.vue";
export default {
  components: { mapSearch },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      deptList: [],
      saving: false,
      formInline: {
        extendLongitude: "",
        extendLatitude: "",
        extendRangeMetre: ""
      },
      mapVisible: false,
      rules: {
        ruleTable: [
          {
            required: true,
            message: "请输入数据源",
            trigger: ["blur", "change"]
          }
        ],
        file: [
          {
            required: true,
            message: "请上传文件",
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },
  created() {
    this.mangerDetailFun();
  },
  methods: {
    confirmLocation(e) {
      this.lnglat = e;
      this.formInline.extendLongitude = e.lng;
      this.formInline.extendLatitude = e.lat;
      this.formInline.extendAddress = e.addr;
      this.mapVisible = false;
    },
    async mangerDetailFun() {
      const res = await mangerDetail();
      if (res.data.code == 200) {
        this.formInline = res.data.data;
      }
    },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    async addOrUpdateFun() {
      this.$refs["form"].validate(async valid => {
        if (valid) {
          this.saving = true;
          let res = await mangerEdit({
            ...this.formInline,
            id: "ZHIBAN"
          });
          this.saving = false;
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "操作成功"
            });
            this.handleClose();
            this.$emit("refreshList");
          } else {
            this.$message({
              type: "error",
              message: res.data.msg
            });
          }
        }
      });
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
@import "~@/components/less.less";
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
  overflow: hidden;
}
.container-dialog {
  overflow: hidden;
  display: flex;
  .left {
    width: 100%;
    // height: 200px;
    overflow: auto;
    margin-right: 24px;
  }
}

/deep/ .specialForm {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/onDuty/fileDialog.vue